module.exports = __webpack_public_path__ + "tamboBlanco.png?234a27a41300aacdc6096d282c99adc1";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tamboBlanco.png
// module id = 171
// module chunks = 2